export { ModelCard, Component } from './ModelCard';
